import { createFileRoute } from "@tanstack/react-router";

import { ClientTabPage } from "@/features/booking/modules/client-page/client-tab-page";
import { ClientRecovery } from "@/features/client-training/modules/client-recovery/client-recovery";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/trainees/$clientId/recovery")({
  loader: () => ({ crumb: m.client_tab_recovery() }),
  component: RouteComponent,
});

function RouteComponent() {
  const { clientId } = Route.useParams();
  return (
    <ClientTabPage clientId={clientId} tab="recovery">
      <ClientRecovery clientId={clientId} />
    </ClientTabPage>
  );
}
